import { ManagedIdentityCredential, type TokenCredential } from "@azure/identity";
import { CHANNEL_LATEST_URL } from "@m8t-stack/platform-release";
import { LocalCliError } from "./errors.js";

export interface HeadlessContext {
  credential: TokenCredential;
  miClientId: string;
  subscriptionId: string;
  resourceGroup: string;
  endpoint: string;      // Foundry data-plane endpoint (pinned)
  channelUrl: string;    // bicep-set channel URL; job self-fetches from here
}

export function resolveHeadlessContextFromEnv(env: NodeJS.ProcessEnv): HeadlessContext {
  const need = (k: string): string => {
    const v = (env[k] ?? "").trim();
    if (!v) throw new LocalCliError({ code: "HEADLESS_ENV_MISSING", message: `converge: required env ${k} is unset` });
    return v;
  };
  const miClientId = need("MI_CLIENT_ID");
  return {
    credential: new ManagedIdentityCredential({ clientId: miClientId }),
    miClientId,
    subscriptionId: need("SUBSCRIPTION_ID"),
    resourceGroup: need("RESOURCE_GROUP"),
    endpoint: need("FOUNDRY_ENDPOINT"),
    channelUrl: (env.M8T_UPDATE_CHANNEL_URL ?? "").trim() || CHANNEL_LATEST_URL,
  };
}
